module.exports = __webpack_public_path__ + "img/p&s-plat2.d8ebaba0.jpg";